import { format, parseISO } from "date-fns";

/**
 * Formata a data para exibição no timestamp da mensagem
 * @param {string} dateString - Data em formato ISO
 * @returns {string} - Data formatada (HH:mm)
 */
export const formatMessageTime = (dateString) => {
  try {
    if (!dateString) return format(new Date(), "HH:mm");
    const d = parseISO(dateString);
    if (isNaN(d)) return format(new Date(), "HH:mm");
    return format(d, "HH:mm");
  } catch {
    try { return format(new Date(), "HH:mm"); } catch { return ""; }
  }
};

/**
 * Formata a data para exibição diária
 * @param {string} dateString - Data em formato ISO
 * @returns {string} - Data formatada (dd/MM/yyyy)
 */
export const formatMessageDate = (dateString) => {
  return format(parseISO(dateString), "dd/MM/yyyy");
};

/**
 * Obtém a data de hoje formatada
 * @returns {string} - Data de hoje (dd/MM/yyyy)
 */
export const getTodayFormatted = () => {
  return format(new Date(), "dd/MM/yyyy");
};

/**
 * Converte string de data ISO para objeto Date
 * @param {string} dateString - Data em formato ISO
 * @returns {Date} - Objeto Date
 */
export const parseMessageDate = (dateString) => {
  return parseISO(dateString);
};
